import React, { PropTypes } from 'react';

import Meta from '../../components/Meta';
import Footer from '../Footer';

import styles from './Page.css';

/**
 * Page wrapper, including meta and footer
 */
const Page = ({ children }) => (
  <div>
    <Meta />
    { children }
    <Footer data={children} />
  </div>
);

Page.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

Page.defaultProps = {
  children: [],
};

export default Page;



// WEBPACK FOOTER //
// ./app/src/components/Page/Page.react.js